module.exports = __webpack_public_path__ + "static/media/om_beard_stiletto_round__oval_shadow.93301e9d.png";